import { render, staticRenderFns } from "./ChatControls.vue?vue&type=template&id=3c959ca9&lang=pug"
import script from "./ChatControls.vue?vue&type=script&lang=ts"
export * from "./ChatControls.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports